export const requiredFields = ["startDate", "endDate"];

// need to update picked travel package values after tarrification
const travelPackageFields = [
  "commision",
  "helpAssistance_Suminsured",
  "helpAssistance_Currency",
  "suminsured_Accident",
  "civilSuminsured",
  "civilCurrency",
  "financialRisk_Currency",
  "otherKof_k7",
  "tariffIncrease",
  "helpAssistance_1_CoverageStatus",
  "helpAssistance_2_CoverageStatus",
  "helpAssistance_3_CoverageStatus",
  "helpAssistance_4_CoverageStatus",
  "helpAssistance_5_CoverageStatus",
  "helpAssistance_6_CoverageStatus",
  "helpAssistance_7_CoverageStatus",
  "helpAssistance_8_CoverageStatus",
  "helpAssistance_9_CoverageStatus",
  "helpAssistance_10_CoverageStatus",
  "helpAssistance_11_CoverageStatus",
  "helpAssistance_12_CoverageStatus",
  "helpAssistance_13_CoverageStatus",
  "helpAssistance_14_CoverageStatus",
  "helpAssistance_15_CoverageStatus",
  "helpAssistance_16_CoverageStatus",
  "helpAssistance_17_CoverageStatus",
  "helpAssistance_18_CoverageStatus",
  "financialRisk_1_CoverageStatus",
  "financialRisk_2_CoverageStatus",
  "financialRisk_3_CoverageStatus",
  "financialRisk_4_CoverageStatus",
  "financialRisk_5_CoverageStatus",
  "financialRisk_6_CoverageStatus",
  "financialRisk_7_CoverageStatus",
  "financialRisk_8_CoverageStatus",
  "financialRisk_9_CoverageStatus",
  "accident_1_CoverageStatus",
  "accident_2_CoverageStatus",
  "accident_3_CoverageStatus",
  "accident_4_CoverageStatus",
  "accident_5_CoverageStatus",
  "accident_6_CoverageStatus",
  "civil_1_CoverageStatus",
  "civil_2_CoverageStatus",

  "Standart_req_data",
  "Business_req_data",
  "Elit_req_data",
  "Vip_req_data",

  // INSURED_COUNT_VAR_LIST
  "insuredTourists",
  "insuredCountAgeFrom0To14",
  "insuredCountAgeFrom15To24",
  "insuredCountAgeFrom25To64",
  "insuredCountAgeFrom65To69",
  "insuredCountAgeFrom70To74",
];

const diiaSharingFields = [
    // INTERNAL_PASSPORT
    "citizenship",
    "documentType",
    "identCode",
    "birthDate",
    "lastName",
    "lastNameLatin",
    "firstName",
    "firstNameLatin",
    "middleName",
    "passportNumber",
    "issuingAuthority",
    "issueDate",

    // VEHICLE_LICENSE
    "plateNumber",
    "vin",
    "model",
    "brand",
    "constructionYear",
    "engineType",
    "totalWeight",
    "ownWeight",
    "placesCount",
    "engineCapacity",

    // FOREIGN_PASSPORT
    "foreignPassportNumber",
    "passportSeries",
]


export const forceUpdateKeys = [
  "premium",
  "finalPremium",
  "billingRedirectUrl",
  "primaryInsuredParty_registrationAddress_Unstructured",
  "primaryInsuredParty_registrationAddress_translitUnstructured",
  "vehicle_registrationBrandModel",
  "primaryInsuredParty_registrationAddress_streetLine",
  "vehicle_beneficiary_registrationAddress_streetLine",
  "vehicleTypePrintout",
  "vehicleTypePrintoutOSCPV",
  "durationValue",
  "datePeriodValue", // zk duration
  "LegkyiZahystPremium_picked_btDCV",
  "LegkyiZahystPremium_picked_btDNV",
  "vehicleTypeValue",
  "territoryOfCoverageValue",
  "persons",
  "forTourists",
  "insuredCount",
  "contractDurationInDays",
  "pickedTravelCalculationCategory",
  "pickedTravelPackage_Premium_Accident",
  "pickedTravelPackage_Premium_Civil",
  "pickedTravelPackage_Premium_FinancialRisk",
  "pickedTravelPackage_Premium_HelpAssistance",
  "pickedTravelPackage_SumInsured_HelpAssistance",
  "pickedTravelPackage_SumInsured_Civil",
  "pickedTravelPackage_SumInsured_Accident",
  "pickedTravelPackage_SumInsured_FinancialRisk",
  "totalCommercialPremium",
  "freeFieldsvariants",
  "vehicleRegisterCityName", // oscpv
  "LegkyiZahystPremium_picked_InsuranceSumDNV",
  "mainPerson_complexGuarantees9_7_704_basicGuarantees00706_guaranteeLimit",
  "mainPerson_complexGuarantees9_7_704_basicGuarantees01164_guaranteeLimit",
  "mainPerson_complexGuarantees9_7_704_basicGuarantees00707_guaranteeLimit",
  "mainPerson_complexGuarantees9_7_704_basicGuarantees01118_guaranteeLimit",
  "mainPerson_complexGuarantees9_7_704_basicGuarantees01119_guaranteeLimit",
  "tariffProgramDMSDTP",
  "objectSignCode_Product",
  "policyDirectLink",
  // reserve date zk
  "mtplContract_creationDateDay",
  "mtplContract_creationDateMonth",
  "mtplContract_creationDateYear",
  "mtplContract_creationDateTime",
  // reserve date oscpv
  "mtsbuOffer_creationDate",
  "priceWithCrosses",
  "vehicleUsage",
  "usageMonths",

  //cross
  "finalPremiumWithoutCross", //
  "pickedCrosses",

  // tourist
  "passportNumber",
  "passportSeries",
  "countryTravelZoneValue",
  "work",
  "sport",
  "translitGivenName",
  "tariffProgram",

  "needPVI",
  "driverAge",
  "ownerBirthYear",
  "autoDescr",
  "constructionYear",
  "dbonusMalusID",
  "dcitizenStatusID",
  "dpersonDocTypeId",
  "dcityID",
  "dexpLimitID",
  "dmarkID",
  "dmodelID",
  "dperiodID",
  "dpersonStatusID",
  "dprivelegeID",
  "dsphereUseID",
  "dvehicleTypeID",
  "vehicleUsage",
  "usageMonths",
  ...travelPackageFields,
  ...diiaSharingFields,
];
